let containerCategories = document.querySelector(".container-categories");
let btnDisplayCategories = document.getElementById("btnDisplayCategories");

if (containerCategories && btnDisplayCategories) {
  btnDisplayCategories.addEventListener("click", function () {
    containerCategories.classList.toggle("visible");
  });

  btnDisplayCategories.addEventListener("click", function () {
    btnDisplayCategories.classList.toggle("visible");
  });
}